// Imports
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register plugins
gsap.registerPlugin(ScrollTrigger);

// Make them globally available
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

// Header title
if (document.querySelector(".animated-header-element")) {
  gsap.from(".animated-header-element", {
    autoAlpha: 0,
    opacity: 0,
    y: 30,
    duration: 1,
    stagger: 0.2,
    ease: "power2.out",
  });
}

// // Header text
// if (document.querySelector(".header-text")) {
//   gsap.from(".header-text", {
//     opacity: 0,
//     y: 40,
//     duration: 1,
//     delay: 0.2,
//     ease: "power2.out",
//   });
// }

// // Header buttons
// if (document.querySelector(".header-buttons")) {
//   gsap.from(".header-buttons", {
//     opacity: 0,
//     y: 50,
//     duration: 1,
//     delay: 0.4,
//     ease: "power2.out",
//   });
// }

// Contact/about header
if (document.querySelector(".header .header-img")) {
  gsap.from(".header .header-img", {
    autoAlpha: 0,
    opacity: 0,
    duration: 1.5,
    ease: "power2.out",
    // delay: 0.2,
  });
}

// // Image parallax (.image-parallax)
// gsap.registerPlugin(ScrollTrigger);

// const imgs = gsap.utils.toArray(".img-parallax");

// imgs.forEach((img) => {
//   gsap.to(img, {
//     y: () => -window.innerHeight * 0.1,
//     ease: "none",
//     scrollTrigger: {
//       trigger: img,
//       start: "top center",
//       end: "center top",
//       scrub: true,
//       invalidateOnRefresh: true,
//       markers: true,
//     },
//   });
// });

// const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// if (reduceMotion) {
//   gsap.globalTimeline.clear(); // removes any animations already created
//   gsap.defaults({ duration: 0 }); // future animations become instant
// }
